(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  class AnnouncementBarSection extends HTMLElement {
    connectedCallback() {
      if (this.dataset.mode !== 'slider') return;

      this.slides = Array.from(this.querySelectorAll('.announcement-bar__slide'));
      if (this.slides.length <= 1) return;

      this.currentIndex = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (this.currentIndex < 0) this.currentIndex = 0;
      this.isAnimating = false;
      this.animationDuration = 450;

      this.prevButton = this.querySelector('.announcement-bar__button--prev');
      this.nextButton = this.querySelector('.announcement-bar__button--next');

      this.handlePrev = () => this.showSlide(this.currentIndex - 1);
      this.handleNext = () => this.showSlide(this.currentIndex + 1);

      if (this.prevButton) this.prevButton.addEventListener('click', this.handlePrev);
      if (this.nextButton) this.nextButton.addEventListener('click', this.handleNext);

      if (this.dataset.autoplay === 'true' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        this.startAutoplay();
        this.addEventListener('mouseenter', this.stopAutoplay.bind(this));
        this.addEventListener('mouseleave', this.startAutoplay.bind(this));
      }
    }

    disconnectedCallback() {
      if (this.prevButton) this.prevButton.removeEventListener('click', this.handlePrev);
      if (this.nextButton) this.nextButton.removeEventListener('click', this.handleNext);
      this.stopAutoplay();
    }

    showSlide(index) {
      if (this.isAnimating) return;

      const total = this.slides.length;
      const nextIndex = (index + total) % total;
      if (nextIndex === this.currentIndex) return;

      const currentSlide = this.slides[this.currentIndex];
      const nextSlide = this.slides[nextIndex];

      this.isAnimating = true;
      currentSlide.classList.add('is-leaving');
      currentSlide.classList.remove('is-active');
      nextSlide.classList.add('is-active');

      window.setTimeout(() => {
        currentSlide.classList.remove('is-leaving');
        this.currentIndex = nextIndex;
        this.isAnimating = false;
      }, this.animationDuration);
    }

    startAutoplay() {
      this.stopAutoplay();
      const interval = Number(this.dataset.interval) || 4000;
      this.autoplayTimer = window.setInterval(() => this.showSlide(this.currentIndex + 1), interval);
    }

    stopAutoplay() {
      if (this.autoplayTimer) {
        window.clearInterval(this.autoplayTimer);
        this.autoplayTimer = null;
      }
    }
  }

  if (!customElements.get('announcement-bar-section')) {
    customElements.define('announcement-bar-section', AnnouncementBarSection);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["background-image-text"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const section = document.currentScript?.closest('.shopify-section')?.querySelector('.background-image-text-section');

    if (!section || section.dataset.parallax !== 'true') return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    const media = section.querySelector('[data-background-media]');
    if (!media) return;

    let ticking = false;

    const updateParallax = () => {
      const rect = section.getBoundingClientRect();
      const progress = (window.innerHeight - rect.top) / (window.innerHeight + rect.height);
      const shift = (progress - 0.5) * 28;
      const axis = getComputedStyle(section).getPropertyValue('--background-image-text-parallax-axis').trim();

      if (axis === 'horizontal') {
        media.style.transform = `translate3d(${shift}px, 0, 0) scale(1.06)`;
      } else {
        media.style.transform = `translate3d(0, ${shift}px, 0) scale(1.06)`;
      }
      ticking = false;
    };

    const requestUpdate = () => {
      if (window.innerWidth <= 749) {
        media.style.transform = 'none';
        return;
      }

      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(updateParallax);
    };

    updateParallax();
    document.addEventListener('scroll', requestUpdate, { passive: true });
    window.addEventListener('resize', requestUpdate);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  class FaqSection extends HTMLElement {
    connectedCallback() {
      // Multi-open FAQ: each item toggles independently; opening one no longer
      // closes the others.
      this._items = Array.from(this.querySelectorAll('details.faq-item'));
    }
  }

  if (!customElements.get('faq-section')) {
    customElements.define('faq-section', FaqSection);
  }

  } catch(e) { console.error(e); }
})();
})();
